import type { ReactNode } from 'react';
import { useBot } from '../contexts/BotContext';
import { selectedBot } from '../lib/systemScope.ts';

/**
 * A1: pages that act on "the current bot" render only once a bot is chosen — there is no default bot any more
 * (it used to be chatbot/7598, so a fresh browser silently queried and edited that bot).
 */
export function RequireBot({ title, children }: { title: string; children: ReactNode }) {
  const { system, botId } = useBot();
  if (selectedBot({ system, botId })) return <>{children}</>;
  return (
    <div className="h-full w-full overflow-y-auto bg-gray-50">
      <div className="mx-auto max-w-5xl px-6 py-8">
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        <p className="mt-4 text-gray-600">Choose a bot in the top bar first.</p>
      </div>
    </div>
  );
}
